import React from 'react';
import { Box } from '@mui/material';
import { NAV_TABS } from '../../utils/categoriesConfig';
import TTSButton from '../Mobile/TTSButton';
import './NavigationBar.css';

const NavigationBar = ({
  type,
  setType,
  language,
  onTTSToggle,
  isTTSPlaying,
  isTTSDisabled,
  audioOutputDevices,
  selectedOutputDeviceId,
  onOutputDeviceChange,
  onTTSRestart
}) => {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid #e0e0e0',
      backgroundColor: '#f5f5f5',
      padding: '0.5rem',
      gap: 1
    }}>
      <Box sx={{ flex: 1 }}>
        <div className="desktop-scroll-container">
          {NAV_TABS.map(tab => (
            <div
              key={tab.id}
              data-value={tab.id}
              className={`desktop-nav-item ${type === tab.id ? 'active' : ''}`}
              onClick={() => setType(tab.id)}
            >
              {tab.label[language] || tab.label.EN}
            </div>
          ))}
        </div>
      </Box>

      {/* TTS Button */}
      {onTTSToggle && (
        <Box sx={{ flexShrink: 0, paddingRight: '0.5rem' }}>
          <TTSButton
            isPlaying={isTTSPlaying}
            isDisabled={isTTSDisabled}
            onToggle={onTTSToggle}
            audioOutputDevices={audioOutputDevices}
            selectedOutputDeviceId={selectedOutputDeviceId}
            onOutputDeviceChange={onOutputDeviceChange}
            onRestart={onTTSRestart}
          />
        </Box>
      )}
    </Box>
  );
};

export default NavigationBar;
